module.exports = __webpack_public_path__ + "img/openapihub.10ee6738.png";